import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
import { utcToLocal, localToUTC } from "../../utils";
function DateTimeWidget(props) {
  var value = props.value,
    _onChange = props.onChange,
    BaseInput = props.registry.widgets.BaseInput;
  return React.createElement(BaseInput, _extends({
    type: "datetime-local"
  }, props, {
    value: utcToLocal(value),
    onChange: function onChange(value) {
      return _onChange(localToUTC(value));
    }
  }));
}
if (process.env.NODE_ENV !== "production") {}
export default DateTimeWidget;